import { Axios } from 'utils'
import {
  ChartKey,
  ITrendChartsFilters,
  TBinDistributionData,
  TCompositionData,
  TConsistencyTrendData,
  TCostTrendData,
  TDistributionData,
  TParametersComparisonData,
  TParametersTrendData,
} from 'types/models/DataAnalysis'

export interface ChartsDataResponse<T> {
  data: Record<string, T>
}

export async function fetchParametersComparison(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TParametersComparisonData>> {
  const { data } = await Axios.post<
    ChartsDataResponse<TParametersComparisonData>
  >(`/analysis/deliveries/parameters_comparison`, filters)
  return data
}

export async function fetchParametersTrend(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TConsistencyTrendData>> {
  const { data } = await Axios.post<ChartsDataResponse<TConsistencyTrendData>>(
    `/analysis/deliveries/parameters_trend`,
    filters
  )
  return data
}

export async function fetchConsistencyTrend(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TParametersTrendData>> {
  const { data } = await Axios.post<ChartsDataResponse<TParametersTrendData>>(
    `/analysis/deliveries/consistency_trend`,
    filters
  )
  return data
}

export async function fetchBinDistribution(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TBinDistributionData>> {
  const { data } = await Axios.post<ChartsDataResponse<TBinDistributionData>>(
    `/analysis/deliveries/bin_distribution`,
    filters
  )
  return data
}

export async function fetchCostTrends(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TCostTrendData>> {
  const { data } = await Axios.post<ChartsDataResponse<TCostTrendData>>(
    `/analysis/blends/cost_trends`,
    filters
  )
  return data
}

export async function fetchCompositions(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TCompositionData>> {
  if (!filters.blend_type) return null
  const { data } = await Axios.post<ChartsDataResponse<TCompositionData>>(
    `/analysis/blends/compositions`,
    { ...filters, blend_type: filters.blend_type?.label }
  )
  return data
}

export async function fetchDistribution(
  filters: ITrendChartsFilters
): Promise<ChartsDataResponse<TDistributionData>> {
  const { data } = await Axios.post<ChartsDataResponse<TDistributionData>>(
    `/analysis/storage/distribution`,
    filters
  )
  return data
}

export function getFetcherForChart(key: ChartKey) {
  switch (key) {
    case 'parameters_comparison':
      return fetchParametersComparison
    case 'parameters_trend':
      return fetchParametersTrend
    case 'consistency_trend':
      return fetchConsistencyTrend
    // case 'spectral_image_comparison': return fetchSpectralImageComparison
    case 'bin_distribution':
      return fetchBinDistribution
    case 'cost_trends':
      return fetchCostTrends
    case 'compositions':
      return fetchCompositions
    case 'storage_distribution':
      return fetchDistribution
    default:
      throw new Error(`No API fetcher mapped for chart key: ${key}`)
  }
}
